
import Cloudkit from '../../images/cloudkit.svg'
import Defaultkit from '../../images/defaultkit.svg'
import Designkit from '../../images/designkit.svg'
import Marketkit from '../../images/marketkit.svg'
import Mobilkit from '../../images/mobilkit.svg'
import Testkit from '../../images/testkit.svg'
import Webkit from '../../images/webkit.svg'
import Nineatoms from '../../images/nineatoms.svg'

import WebkitWrapper from '../../images/wrappers/webkit_wrapper.svg'
import DesignkitWrapper from '../../images/wrappers/designkit_wrapper.svg'
import MarketkitWrapper from '../../images/wrappers/marketkit_wrapper.svg'
import MobilkitWrapper from '../../images/wrappers/mobilkit_wrapper.svg'
import TestkitWrapper from '../../images/wrappers/testkit_wrapper.svg'
import CloudkitWrapper from '../../images/wrappers/cloudkit_wrapper.svg'

export const colorPalette = {
    primary: '#FF4C00', //Alternative: #030092
}

export const wrappers = {
    'webkit': WebkitWrapper,
    'designkit': DesignkitWrapper,
    'marketkit': MarketkitWrapper,
    'mobilkit': MobilkitWrapper,
    'testkit': TestkitWrapper,
    'cloudkit': CloudkitWrapper
}

export const images = {
    'cloudkit': Cloudkit,
    'defaultkit': Defaultkit,
    'designkit': Designkit,
    'marketkit': Marketkit,
    'mobilkit': Mobilkit,
    'testkit': Testkit,
    'webkit': Webkit,
    'nineatoms' : Nineatoms,
}


export const display_items = {
    tiles: [
        {id: '0'},
        {id: '1'},
        {id: '2'},
    ]
}


export const section = 
{
    id: 'testkit',
    wrapped: true,
    bg_color: '#111',
    img_first: true,
    wrapper_left: false,
    seperator: false,
    larger: true,
    title: [
        {
            id: '0',
            text: 'TEST',
            color: colorPalette['primary'],
            bg_color: '',
            font: 'Righteous',
            font_size: '5vw',
        },
        {
            id: '1',
            text: 'KIT',
            color: '',
            bg_color: '',
            font: 'Righteous',
            font_size: '5vw',
        },
    ],
    description: {
        text: 'Conversion optimization, measuring, data and reporting solutions',
        color: '',
        bg_color: '',
        font: '',
        font_size: '1.6vw',
    },
    button: {
        text: 'Contact',
        arrow: 'false',
        color: colorPalette['primary'],
        font: '',
        font_size: '1.6vw',
        img_first: 'true',
    }
}

export const section_title = {
    text: 'TESTKIT',
    left: true,
    bg_color: colorPalette['primary'],
    font: 'Michroma',
    font_size: '5vw',
}

export const section_small_title1 = {
    text: 'What is Test KIT?',
    left: false,
    solo: false,
    bg_color: colorPalette['primary'],
    font: 'Michroma',
    font_size: '3vw',
    desc_font_size: '1.6vw',
    description: 'Conversion optimization, measuring, data and reporting solutions SDAKJJFK jdsjfg dkskkf afmö aman dnkkldf dfjjr sdjeı sdı dsfjjf dfjj dfjjf dfjk dkjferoe ckjgfx dfjddfroe djfdfods',
    text_align: '',
}

export const section_small_title2 = {
    text: 'What is Test KIT?',
    left: true,
    solo: false,
    bg_color: colorPalette['primary'],
    font: 'Michroma',
    font_size: '3vw',
    desc_font_size: '1.6vw',
    description: 'Conversion optimization, measuring, data and reporting solutions SDAKJJFK jdsjfg dkskkf afmö aman dnkkldf dfjjr sdjeı sdı dsfjjf dfjj dfjjf dfjk dkjferoe ckjgfx dfjddfroe djfdfods',
    text_align: '',
}

export const columned_cards = {
    title_text: 'Details',
    bg_color: colorPalette['primary'],
    font: 'Michroma',
    font_size: '3vw',
    desc_font_size: '1.2vw',
    cards: [
        [{
            id: '0',
            title_text: 'System Design & Developmnet',
            description_text: [
                {id: '0', text: 'A unique tailor-cut solution for your needs,'},
                {id: '1', text: 'System flow and design by a Technical Design Authority,'},
                {id: '2', text: 'End-to-end development, '},
                {id: '3', text: 'User and backend interface design,'},
                {id: '4', text: '3rd party service integrations,'},
                {id: '5', text: 'Education and documentation'},
            ],
        },
        {
            id: '1',
            title_text: 'PHP Development',
            description_text: [
                {id: '0', text: 'Custom PHP Web Development'},
                {id: '1', text: 'Custom PHP Programming'},
                {id: '2', text: 'Payment Gateway Integration'},
                {id: '3', text: 'Maintenance & Support'},
                {id: '4', text: 'Bug & Error Fixes, General System Improvements'},
            ],
        }],[
        {
            id: '2',
            title_text: 'Wordpress Development',
            description_text: [
                {id: '0', text: 'WordPress Theme Development'},
                {id: '1', text: 'WordPress Plugin Development'},
                {id: '2', text: 'PSD/HTML to WordPress'},
                {id: '3', text: 'Custom WordPress Solutions'},
                {id: '4', text: 'Support & Maintenance'},
                {id: '5', text: 'Responsiveness & Mobility'},
                {id: '6', text: 'Bug & Error Fixes, General System Improvements'},
            ],
        }]
    ]
}

export const section_small_title3 = {
    text: 'Reviews',
    left: false,
    bg_color: colorPalette['primary'],
    font: 'Michroma',
    font_size: '3vw',
    solo: true,
    text_align: '',
}

export const Slides = [
    {
        id: '0',
        text: 'Now about the time that Zarathustra sojourned on the Happy Isles, it happened that a ship anchored at the isle on which standeth the smoking mountain, and the crew went ashore to shoot rabbits. About the noontide hour, however, when the captain and his men were together again, they saw suddenly a man coming towards them through the air, and a voice said distinctly: "It is time! It is the highest time!"',
        fullname: 'Tom Hobbes',
    },
    {
        id: '1',
        text: 'Wordfdk  dglk sdklkl rtkoo drtkg rtlşlkdrt  krtrpto fdtkrtokb rebk trbkjplgj tobvko bjkjbjk bvkfgvjkj bjkvgprojkb fglrftojbk vkgjrjyt  trkjttbv  ftkrlptory tkrpotrpytokprky mrmrpskf rkrlr dkldl flpd dkl fglfpytpswöxmö fkghşc b hglptoy fkfdps',
        fullname: 'Mr. Smith',
    },
    {
        id: '2',
        text: 'Thus spake the disciple; and all the others then thronged around Zarathustra, grasped him by the hands, and tried to persuade him to leave his bed and his sadness, and return unto them. Zarathustra, however, sat upright on his couch, with an absent look.',
        fullname: 'Daniel Crowfort',
    },
    {
        id: '3',
        text: 'And when I came out of my solitude, and for the first time passed over this bridge, then I could not trust mine eyes, but looked again and again, and said at last: "That is an ear! An ear as big as a man!" I looked still more attentively--and actually there did move under the ear something that was pitiably small and poor and slim. And in truth this immense ear was perched on a small thin stalk--the stalk, however, was a man!',
        fullname: 'Bogdan Bogusław',
    },
];

export const imageWText = 
{
    wrapped: false,
    bg_color: '',
    img_first: true,
    wrapper_left: true,
    seperator: false,
    larger: true,
    title: [],
    description: {
        text: 'Conversion optimization, measuring, data and reporting solutions',
        color: '',
        bg_color: '',
        font: '',
        font_size: '1.6vw',
    },
    button: {
        display: false,
        text: 'Contact',
        arrow: 'false',
        color: colorPalette['primary'],
        font: '',
        font_size: '1.6vw',
        img_first: 'true',
    }
}

export const section_small_title_left = {
    text: 'How does TestKit work?',
    left: false,
    solo: false,
    bg_color: colorPalette['primary'],
    font: 'Michroma',
    font_size: '2.4vw',
    desc_font_size: '1.6vw',
    description: 'You can choose from three options and they are 2 hours, 8 hours, and 24 hours package. If you need more than that, you can always combine the options. After we understood your need, we will make a plan, and offer you option(s) which will be the most suitable for you. Once we complete your project, we will use the remaining hours to improve your system or/and fix other problems you have.',
    text_align: 'left',
}


export const CardColumns = [
    {
        id: '0',
        duration: 2,
        text: 'Hours Testkit for',
        currency: '$',
        price: 300,
        button_text: 'Start Now'
    },{
        id: '1',
        duration: 2,
        text: 'Hours Testkit for',
        currency: '$',
        price: 300,
        button_text: 'Start Now'
    },{
        id: '2',
        duration: 2,
        text: 'Hours Testkit for',
        currency: '$',
        price: 300,
        button_text: 'Start Now'
    }
    
]

export const BCT_Text1 = [
    {
        id: '0',
        arrow: 'true',
        lines:[
            "Interested in our KITS?",
            "Get in touch with us."
        ],
        button: {
            display: true,
            text: "Contact"
        },
    },
    {
        id: '1',
        arrow: 'true',
        lines:[
            "Interested in our KITS?",
            "Get in touch with us."
        ],
        button: {
            display: true,
            text: "Contact"
        },
    },
    {
        id: '2',
        arrow: 'true',
        lines:[
            "Interested in our KITS?",
            "Get in touch with us."
        ],
        button: {
            display: true,
            text: "Contact"
        },
    },
    {
        id: '3',
        arrow: 'true',
        lines:[
            "Interested in our KITS?",
            "Get in touch with us."
        ],
        button: {
            display: true,
            text: "Contact"
        },
    },
]


export const adsSection = {
    columns: [
        {
            id: '0',
            imgID: "testkit",
            title: [
                {
                    id: '0',
                    text: 'TEST',
                    color: colorPalette['primary'],
                    bg_color: '',
                    font: 'Righteous',
                    font_size: '3vw',
                },
                {
                    id: '1',
                    text: 'KIT',
                    color: '',
                    bg_color: '',
                    font: 'Righteous',
                    font_size: '3vw',
                },
            ],
            desc_text: "Conversion optimization, measuring, data and reporting solutions",
            button: {
                text: 'See Details',
                color: colorPalette['primary'],
                font: '',
            },
        },
        {
            id: '1',
            imgID: "webkit",
            title: [
                {
                    id: '0',
                    text: 'WEB',
                    color: colorPalette['primary'],
                    bg_color: '',
                    font: 'Righteous',
                    font_size: '3vw',
                },
                {
                    id: '1',
                    text: 'KIT',
                    color: '',
                    bg_color: '',
                    font: 'Righteous',
                    font_size: '3vw',
                },
            ],
            desc_text: "Conversion optimization, measuring, data and reporting solutions",
            button: {
                text: 'See Details',
                color: colorPalette['primary'],
                font: '',
            },
        },
    ]
}
